/** @format */

import React, { useEffect } from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { Container } from "react-bootstrap";

import { singleService } from "../../../Features/HomeApi/HomeSlice";
import Loader from "../Loader/Loader";
import Discussions from "../../DashboardView/Container/DiscussionPage/Discussions";
import PageHeadings from "../PageHeadings";
import SEO from "../Seo/Seo";

const ModuleDiscussion = () => {
  const dispatch = useDispatch();

  const dictionaryItem = useSelector((state) => state.home.allDictionary);
  const selectedService = useSelector(
    (state) => state.home.selectedSingleService,
    shallowEqual,
  );
  const isLoading = useSelector((state) => state.home.homeModuleLoading);
  const seoData = selectedService?.seo_data;

  // Fetch service (id: 5)
  useEffect(() => {
    dispatch(singleService({ id: 5 }));
  }, [dispatch]);

  // Extract SEO data safely
  const metaTitle =
    selectedService?.seo_data?.meta_title ||
    selectedService?.title ||
    "LKWB Discussions";
  const metaDescription =
    selectedService?.excerpt ||
    selectedService?.seo_data?.meta_description ||
    "Join the LKWB discussions and improve your Korean learning.";
  const metaKeywords =
    selectedService?.seo_data?.meta_keywords?.join(", ") ||
    "discussion, korean, LKWB";
  const canonicalUrl =
    selectedService?.seo_data?.canonical_url || "/discussion";

  return (
    <>
      {seoData && (
        <SEO
          title={seoData.meta_title}
          description={seoData.meta_description}
          keywords={seoData.meta_keywords?.join(", ")}
          path={seoData.canonical_url}
        />
      )}

      {dictionaryItem && (
        <>
          <PageHeadings item={selectedService} hasIcon="true" />
          <Container>
            {!isLoading ?
              <div className="homediscussion-container home__dictionary">
                <Discussions from="home" />
              </div>
            : <div className="loading__mode">
                <Loader />
              </div>
            }
          </Container>
        </>
      )}
    </>
  );
};

export default ModuleDiscussion;
